import type { WidgetConfig } from "./lib/config";

export const FONTS_HREF =
  "https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&family=Oswald:wght@400;700&display=swap";

export const styleText = `
  :host {
    color: #111827;
    font-family: var(--gitg-font-body);
    line-height: 1.5;
  }

  *, *::before, *::after {
    box-sizing: border-box;
  }

  .gitg-widget {
    position: relative;
    border: 1px solid #e5e7eb;
    border-radius: var(--gitg-radius);
    background: #ffffff;
    color: #111827;
    overflow: hidden;
  }

  .gitg-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background: var(--gitg-bg-toolbar);
    border: 1px solid #e5e7eb;
    border-radius: 4px;
    font-family: 'Montserrat', sans-serif;
  }

  .gitg-toolbar-search {
    display: inline-flex;
    align-items: center;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    background: #ffffff;
    padding: 2px 6px;
    height: 28px;
  }

  .gitg-toolbar-search-input {
    border: 0;
    background: transparent;
    outline: none;
    font: inherit;
    font-size: 0.875rem;
    width: 140px;
    color: #111827;
  }

  .gitg-toolbar-search-input::placeholder {
    color: #9ca3af;
  }

  .gitg-toolbar-search-input::-webkit-search-cancel-button,
  .gitg-toolbar-search-input::-webkit-search-decoration {
    -webkit-appearance: none;
    appearance: none;
  }

  .gitg-toolbar-search-clear {
    border: 0;
    background: transparent;
    cursor: pointer;
    padding: 2px 4px;
    color: #6b7280;
    font-size: 0.875rem;
    line-height: 1;
    display: inline-grid;
    place-items: center;
  }

  .gitg-toolbar-search-clear:hover {
    color: #111827;
  }

  .gitg-toolbar-date-nav {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .gitg-toolbar-date-btn {
    display: inline-grid;
    place-items: center;
    width: 28px;
    height: 28px;
    border: 1px solid #d1d5db;
    background: #ffffff;
    border-radius: 4px;
    padding: 0;
    cursor: pointer;
    font: inherit;
    font-size: 0.875rem;
    color: #374151;
  }

  .gitg-toolbar-date-btn:hover {
    background: #f9fafb;
  }

  .gitg-toolbar-date-input {
    width: 120px;
    border: 1px solid #d1d5db;
    background: #ffffff;
    border-radius: 4px;
    padding: 2px 6px;
    font: inherit;
    font-size: 0.875rem;
    color: rgb(85, 85, 85);
    height: 28px;
  }

  .gitg-toolbar-spacer {
    flex: 1 1 auto;
  }

  .gitg-toolbar-views {
    display: inline-flex;
    border: 1px solid #d1d5db;
    border-radius: 4px;
    overflow: hidden;
    background: #ffffff;
  }

  .gitg-toolbar-view-btn {
    border: 0;
    background: transparent;
    padding: 4px 12px;
    cursor: pointer;
    font: inherit;
    font-size: 0.875rem;
    color: #374151;
    border-right: 1px solid #e5e7eb;
    height: 28px;
  }

  .gitg-toolbar-view-btn:last-child {
    border-right: 0;
  }

  .gitg-toolbar-view-btn:hover {
    background: #f3f4f6;
  }

  .gitg-toolbar-view-btn--active {
    background: #e7dfd0;
    color: #111827;
  }

  .gitg-page-title {
    margin: 0;
    padding: 14px 18px 12px;
    border-bottom: 1px solid #f3f4f6;
    font-family: 'Oswald', sans-serif;
    font-size: 32px;
    font-weight: 400;
    color: rgb(34, 34, 34);
    letter-spacing: 0;
  }

  .gitg-header {
    padding: 16px 18px;
    border-bottom: 1px solid #e5e7eb;
    background: #f9fafb;
  }

  .gitg-title {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
  }

  .gitg-subtitle {
    margin: 4px 0 0;
    font-size: 0.875rem;
    color: #6b7280;
  }

  .gitg-list {
    display: grid;
    gap: 0;
  }

  .gitg-item {
    border-top: 1px solid #f3f4f6;
  }

  .gitg-item:first-child {
    border-top: 0;
  }

  .gitg-item-button {
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    gap: 14px;
    align-items: start;
    width: 100%;
    padding: 16px 18px;
    border: 0;
    background: transparent;
    color: inherit;
    text-align: left;
    cursor: pointer;
    font: inherit;
  }

  .gitg-item-button:hover {
    background: #f9fafb;
  }

  .gitg-item-content {
    min-width: 0;
  }

  .gitg-item-image {
    width: 88px;
    min-width: 88px;
    aspect-ratio: 1;
    border: 1px solid #e5e7eb;
    border-radius: var(--gitg-radius);
    object-fit: cover;
  }

  .gitg-item-image-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 88px;
    min-width: 88px;
    aspect-ratio: 1;
    border: 1px solid #e5e7eb;
    border-radius: var(--gitg-radius);
    background: #f3f4f6;
    color: #9ca3af;
  }

  .gitg-item-button:focus-visible,
  .gitg-store-link:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: -2px;
  }

  .gitg-item-title {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
  }

  .gitg-meta {
    display: grid;
    gap: 4px;
    margin-top: 8px;
    color: #374151;
    font-size: 0.9375rem;
  }

  .gitg-label {
    display: inline-flex;
    align-items: center;
    padding: 1px 4px;
    border: 1px solid rgb(85, 149, 255);
    border-radius: 2px;
    background: transparent;
    color: rgb(85, 149, 255);
    font-family: 'Oswald', sans-serif;
    font-size: 12px;
    font-weight: 400;
  }

  .gitg-label--featured {
    border-color: var(--gitg-color-accent);
    color: var(--gitg-color-accent);
  }

  .gitg-label-external {
    border-color: rgb(82, 82, 91);
    color: rgb(82, 82, 91);
  }

  /* Same tone as the External pill; mirrors the app's notice strip. */
  .gitg-external-notice {
    margin: 0 0 4px;
    color: rgb(82, 82, 91);
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .gitg-description {
    margin: 10px 0 0;
    color: #4b5563;
    font-size: 0.9375rem;
    white-space: pre-line;
  }

  .gitg-description-link {
    color: inherit;
    text-decoration: underline;
  }

  .gitg-description-link:hover {
    opacity: 0.8;
  }

  .gitg-modal {
    position: fixed;
    inset: 0;
    z-index: 2147483647;
    display: grid;
    align-items: center;
    justify-items: center;
    padding: 16px;
  }

  .gitg-modal-backdrop {
    position: fixed;
    inset: 0;
    border: 0;
    background: rgba(17, 24, 39, 0.56);
    cursor: pointer;
  }

  .gitg-detail {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    width: min(560px, calc(100vw - 32px));
    max-height: min(calc(100vh - 32px), 720px);
    overflow: hidden;
    border-radius: var(--gitg-modal-radius);
    background: #ffffff;
    box-shadow: 0 20px 50px rgba(17, 24, 39, 0.24);
  }

  /* The body scrolls; footers (external CTA / app links) stay pinned. */
  .gitg-detail-body {
    display: grid;
    gap: 16px;
    padding: 18px;
    overflow-y: auto;
  }

  .gitg-detail-footer {
    flex-shrink: 0;
    padding: 12px 18px 18px;
    border-top: 1px solid #f3f4f6;
    background: #ffffff;
  }

  .gitg-detail-header {
    display: grid;
    gap: 10px;
  }

  .gitg-detail-image {
    width: 100%;
    max-height: 240px;
    border-radius: var(--gitg-modal-radius);
    object-fit: cover;
  }

  .gitg-close-button {
    position: absolute;
    top: 12px;
    right: 12px;
    display: grid;
    place-items: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: 0;
    border-radius: 999px;
    background: #f3f4f6;
    color: #374151;
    cursor: pointer;
    font-size: 1.25rem;
    line-height: 1;
  }

  .gitg-close-button:hover {
    background: #e5e7eb;
  }

  .gitg-close-button:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: 1px;
  }

  .gitg-detail-title {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 700;
  }

  .gitg-detail-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .gitg-detail-section {
    display: grid;
    gap: 6px;
  }

  .gitg-detail-section-header {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
  }

  .gitg-detail-label {
    margin: 0;
    color: #6b7280;
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .gitg-detail-maps-link {
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: var(--gitg-color-link);
    text-decoration: none;
  }

  .gitg-detail-maps-link:hover {
    text-decoration: underline;
  }

  .gitg-detail-contact-link {
    color: var(--gitg-color-link);
    text-decoration: none;
  }

  .gitg-detail-contact-link:hover {
    text-decoration: underline;
  }

  .gitg-detail-text {
    margin: 0;
    color: #111827;
    font-size: 0.9375rem;
    white-space: pre-line;
  }

  .gitg-event-link-notice {
    margin: 0;
    color: #6b7280;
    font-size: 0.875rem;
  }

  .gitg-event-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 8px 16px;
    border: 0;
    border-radius: var(--gitg-radius);
    background: #2563eb;
    color: #ffffff;
    text-decoration: none;
    font-size: 0.875rem;
    font-weight: 600;
    transition: background 0.15s;
  }

  .gitg-event-link:hover {
    background: #1d4ed8;
  }

  /* Hollow variant: the action happens off-site, not in the app. */
  .gitg-event-link-external {
    display: flex;
    width: 100%;
    padding: 7px 15px;
    border: 1px solid #2563eb;
    background: transparent;
    color: #2563eb;
    transition: background 0.15s, color 0.15s;
  }

  .gitg-event-link-external:hover {
    background: rgba(37, 99, 235, 0.08);
    color: #1d4ed8;
  }

  .gitg-event-link svg {
    width: 14px;
    height: 14px;
  }

  .gitg-share-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }

  .gitg-share-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    border: 1px solid #e5e7eb;
    border-radius: var(--gitg-radius);
    background: #ffffff;
    color: #374151;
    text-decoration: none;
    cursor: pointer;
    font: inherit;
    transition:
      background 0.15s,
      color 0.15s,
      border-color 0.15s;
  }

  .gitg-share-button:hover {
    background: #f9fafb;
    color: var(--gitg-color-link);
    border-color: var(--gitg-color-link);
  }

  .gitg-share-button:focus-visible {
    outline: 2px solid var(--gitg-color-link);
    outline-offset: 2px;
  }

  .gitg-share-button.gitg-share-button-copied,
  .gitg-share-button.gitg-share-button-copied:hover {
    background: #ecfdf5;
    border-color: #10b981;
    color: #047857;
  }

  .gitg-share-button svg {
    width: 18px;
    height: 18px;
  }

  .gitg-register {
    display: grid;
    gap: 12px;
  }

  .gitg-register-label {
    margin: 0;
    color: #374151;
    font-size: 0.9375rem;
    font-weight: 600;
  }

  .gitg-store-links {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }

  .gitg-store-link {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 10px 16px 10px 12px;
    border: 0;
    border-radius: var(--gitg-radius);
    background: #111827;
    color: #ffffff;
    text-decoration: none;
    transition: background 0.15s;
  }

  .gitg-store-link:hover {
    background: #1f2937;
  }

  .gitg-store-icon {
    width: 20px;
    height: 24px;
    flex: 0 0 auto;
  }

  .gitg-store-copy {
    display: grid;
    gap: 1px;
  }

  .gitg-store-eyebrow,
  .gitg-store-name {
    display: block;
  }

  .gitg-store-eyebrow {
    color: rgba(255, 255, 255, 0.65);
    font-size: 0.6875rem;
    font-weight: 400;
    line-height: 1.2;
  }

  .gitg-store-name {
    color: #ffffff;
    font-size: 0.9375rem;
    font-weight: 700;
    line-height: 1.2;
  }

  @media (max-width: 640px) {
    .gitg-modal {
      padding: 12px;
    }

    .gitg-detail {
      width: calc(100vw - 24px);
      max-height: calc(100vh - 24px);
    }

    .gitg-detail-body {
      padding: 16px;
    }

    .gitg-detail-footer {
      padding: 12px 16px 16px;
    }

    .gitg-toolbar-search-input {
      width: 90px;
    }
  }

  .gitg-load-more {
    display: flex;
    justify-content: center;
    padding: 12px 18px;
    border-top: 1px solid #f3f4f6;
  }

  .gitg-load-more-button {
    padding: 8px 20px;
    border: 1px solid #e5e7eb;
    border-radius: var(--gitg-radius);
    background: #ffffff;
    color: #374151;
    cursor: pointer;
    font: inherit;
    font-size: 0.875rem;
    font-weight: 600;
    transition: background 0.15s;
  }

  .gitg-load-more-button:hover {
    background: #f9fafb;
  }

  .gitg-load-more-button:disabled {
    opacity: 0.5;
    cursor: default;
  }

  .gitg-load-more-button:focus-visible {
    outline: 2px solid #2563eb;
    outline-offset: -2px;
  }

  .gitg-list-footer-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    padding: 12px 18px;
    border-top: 1px solid #f3f4f6;
  }

  .gitg-link-load-more,
  .gitg-link-full-calendar {
    background: transparent;
    border: 0;
    padding: 4px 0;
    cursor: pointer;
    font: inherit;
    font-size: 0.6875rem;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #6b7280;
    text-decoration: none;
  }

  .gitg-link-load-more:hover,
  .gitg-link-full-calendar:hover {
    color: #111827;
  }

  .gitg-link-load-more:disabled {
    opacity: 0.5;
    cursor: default;
  }

  .gitg-state {
    padding: 18px;
    color: #4b5563;
    font-size: 0.9375rem;
  }

  .gitg-state--error {
    color: #b91c1c;
  }

  .gitg-monthly {
    display: flex;
    flex-direction: column;
    --gitg-month-day-min-h: 90px;
  }

  .gitg-month-label {
    margin: 0;
    padding: 14px 18px 12px;
    border-bottom: 1px solid #f3f4f6;
    font-family: 'Oswald', sans-serif;
    font-size: 32px;
    font-weight: 400;
    color: rgb(34, 34, 34);
    letter-spacing: 0;
  }

  .gitg-month-weekdays {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    padding: 0 12px;
    border-bottom: 1px solid #f3f4f6;
  }

  .gitg-month-weekday {
    padding: 6px 8px;
    font-size: 0.75rem;
    color: #6b7280;
    text-transform: none;
  }

  .gitg-month-grid {
    display: flex;
    flex-direction: column;
    padding: 0 12px 12px;
  }

  .gitg-month-week {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    border-bottom: 1px solid #f3f4f6;
  }

  .gitg-month-week:last-child {
    border-bottom: 0;
  }

  .gitg-month-vdivider {
    border-left: 1px solid #f3f4f6;
    pointer-events: none;
  }

  .gitg-month-day-num {
    padding: 6px 8px 2px;
    font-size: 0.8125rem;
    color: #6b7280;
    line-height: 1.2;
    text-align: right;
  }

  .gitg-month-day-num--out {
    opacity: 0.4;
  }

  .gitg-month-day-num--today {
    color: var(--gitg-color-link);
    text-decoration: underline;
    font-weight: 700;
  }

  .gitg-month-day {
    background: transparent;
    min-height: 90px;
    padding: 2px 4px 6px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .gitg-month-day--out .gitg-month-event {
    opacity: 0.6;
  }

  .gitg-month-event {
    display: flex;
    flex-direction: column;
    gap: 2px;
    align-items: stretch;
    background: #ffffff;
    border: 1px solid var(--gitg-color-link);
    border-radius: 4px;
    padding: 4px;
    cursor: pointer;
    font: inherit;
    color: inherit;
    text-align: left;
  }

  .gitg-month-event:hover {
    background: #f9fafb;
  }

  .gitg-month-event-image {
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    border-radius: 2px;
  }

  .gitg-month-event-time {
    font-size: 0.6875rem;
    color: #6b7280;
    line-height: 1.2;
  }

  .gitg-month-event-name {
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.25;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .gitg-month-event-span {
    align-self: stretch;
    height: 35px;
    margin: 1px 2px;
    padding: 2px 6px;
    background: #ffffff;
    border: 1px solid var(--gitg-color-link);
    border-radius: 4px;
    cursor: pointer;
    font: inherit;
    color: inherit;
    text-align: left;
    display: flex;
    flex-direction: column;
    gap: 0;
    overflow: hidden;
  }

  .gitg-month-event-span:not(.gitg-month-event-span--start) {
    margin-left: -2px;
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .gitg-month-event-span:not(.gitg-month-event-span--end) {
    margin-right: -2px;
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .gitg-month-event-span:hover {
    background: #f9fafb;
  }

  .gitg-month-event-span-date {
    font-size: 0.6875rem;
    color: #6b7280;
    line-height: 1.2;
  }

  .gitg-month-event-span-name {
    font-size: 0.75rem;
    font-weight: 600;
    line-height: 1.25;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  @media (max-width: 640px) {
    .gitg-monthly {
      --gitg-month-day-min-h: 70px;
    }

    .gitg-month-day {
      min-height: 70px;
      padding: 2px 3px;
    }

    .gitg-month-event-name {
      -webkit-line-clamp: 2;
    }
  }

  .gitg-pinboard-grid {
    column-count: var(--gitg-pinboard-cols, 4);
    column-gap: 12px;
    padding: 12px 18px 18px;
  }

  .gitg-pinboard-card {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 0 12px;
    background: #ffffff;
    border: 1px solid rgb(221, 221, 221);
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    font: inherit;
    color: inherit;
    text-align: left;
    padding: 0;
    break-inside: avoid;
    transition: transform 0.15s, box-shadow 0.15s;
  }

  .gitg-pinboard-card:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(17, 24, 39, 0.08);
  }

  .gitg-pinboard-card:hover .gitg-pinboard-card-title {
    text-decoration: underline;
  }

  .gitg-pinboard-card-image,
  .gitg-pinboard-card-placeholder {
    width: 100%;
    aspect-ratio: 1;
    object-fit: cover;
    display: block;
  }

  .gitg-pinboard-card-placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f3f4f6;
    color: #9ca3af;
  }

  .gitg-pinboard-card-body {
    padding: 10px 12px;
    display: grid;
    gap: 6px;
  }

  .gitg-pinboard-card-date {
    margin: 0;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: rgb(34, 34, 34);
  }

  .gitg-pinboard-card-title {
    margin: 0;
    font-family: 'Oswald', sans-serif;
    font-size: 19px;
    font-weight: 400;
    color: rgb(85, 149, 255);
    line-height: 1.25;
  }

  .gitg-pinboard-card-description {
    margin: 0;
    font-family: 'Oswald', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: rgb(34, 34, 34);
  }

  .gitg-pinboard-card-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin: 4px -12px 0;
    padding: 10px 12px 0;
    border-top: 1px solid rgb(221, 221, 221);
  }

  @media (max-width: 720px) {
    .gitg-pinboard-grid {
      column-count: 2;
    }
  }

  @media (max-width: 400px) {
    .gitg-pinboard-grid {
      column-count: 1;
    }
  }

  .gitg-list--frontpage {
    --gitg-radius: 0;
    border-top: 5px solid rgb(0, 121, 194);
  }

  .gitg-widget:has(.gitg-list--frontpage) {
    border-radius: 0;
  }

  .gitg-list--frontpage .gitg-item-button {
    padding: 7.5px 10px;
  }

  .gitg-list--frontpage .gitg-item-image,
  .gitg-list--frontpage .gitg-item-image-placeholder {
    width: 78px;
    min-width: 78px;
    margin: 0 0;
  }

  .gitg-list--frontpage .gitg-item-title {
    font-family: 'Oswald', sans-serif;
    font-size: 16.5px;
    font-weight: 400;
    color: rgb(0, 121, 194);
  }

  .gitg-list--frontpage .gitg-meta {
    font-family: 'Oswald', sans-serif;
    font-size: 15px;
    font-weight: 700;
    color: rgb(51, 51, 51);
  }

  .gitg-list--frontpage + .gitg-list-footer-links .gitg-link-load-more,
  .gitg-list--frontpage + .gitg-list-footer-links .gitg-link-full-calendar {
    font-family: 'Oswald', sans-serif;
    font-size: 12.75px;
    font-weight: 400;
    letter-spacing: 0;
    color: rgb(51, 51, 51);
  }

  .gitg-list--frontpage + .gitg-list-footer-links .gitg-link-load-more:hover,
  .gitg-list--frontpage + .gitg-list-footer-links .gitg-link-full-calendar:hover {
    color: rgb(51, 51, 51);
    text-decoration: underline;
  }

  .gitg-list--agenda .gitg-item-image,
  .gitg-list--agenda .gitg-item-image-placeholder {
    width: 136px;
    min-width: 136px;
    margin: 0;
  }

  .gitg-list--agenda .gitg-item-title {
    font-family: 'Oswald', sans-serif;
    font-size: 24px;
    font-weight: 400;
    color: rgb(85, 149, 255);
  }

  .gitg-list--agenda .gitg-meta {
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 700;
    color: rgb(34, 34, 34);
  }

  .gitg-list--agenda .gitg-description {
    font-family: 'Oswald', sans-serif;
    font-size: 14px;
    font-weight: 400;
    color: rgb(34, 34, 34);
    white-space: normal;
  }

  .gitg-widget:has(
    :is(.gitg-list--agenda, .gitg-monthly, .gitg-pinboard-grid)
  ) {
    --gitg-radius: 0;
    border-width: 0 0 1px;
  }

  .gitg-item-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 10px;
  }

  .gitg-list--frontpage .gitg-item-tags {
    display: none;
  }
`;

const DEFAULT_FONT_DISPLAY =
  'Georgia, "Iowan Old Style", "Apple Garamond", serif';
const DEFAULT_FONT_BODY = "Oswald, sans-serif";

export function buildVarStyle(config: WidgetConfig): string {
  return `:host {
    --gitg-radius: ${config.roundness};
    --gitg-modal-radius: ${config.modalRoundness};
    --gitg-bg-toolbar: ${config.themeToolbarBg ?? "#f5efe6"};
    --gitg-color-link: ${config.themeLinkColor ?? "#1d4ed8"};
    --gitg-color-accent: ${config.themeAccentColor ?? "#ea580c"};
    --gitg-font-display: ${config.themeFontDisplay ?? DEFAULT_FONT_DISPLAY};
    --gitg-font-body: ${config.themeFontBody ?? DEFAULT_FONT_BODY};
    --gitg-pinboard-cols: ${config.pinboardColumns};
  }`;
}
